import Head from "next/head";
import { ActivateScreen } from "@medbillai/app/screens/auth/activate";
import { BotControlProvider } from "@medbillai/app/screens/auth/components/BotControlProvider";
import { SignUpOnboardingLayout } from "@medbillai/app/screens/sign-up-onboarding/layout.web";
import { SlidingLayout } from "../utils/transition/SlidingLayout";
import type { NextPageWithLayout } from "./_app";
export const Page: NextPageWithLayout = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="activate.tsx">
        <title>Get Started</title>
      </Head>
      <ActivateScreen data-sentry-element="ActivateScreen" data-sentry-source-file="activate.tsx" />
    </>;
};
Page.getLayout = page => <SignUpOnboardingLayout heroImageSrc="/static/onboarding/partner-signup-hero.jpg">
    <SlidingLayout>
      <BotControlProvider>{page}</BotControlProvider>
    </SlidingLayout>
  </SignUpOnboardingLayout>;
export default Page;